import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Utente, UpdatePasswordRequest } from '../../../shared/models/user.model';
import { ConfigService } from '../../../shared/services/config.service';

@Injectable({ providedIn: 'root' })
export class UserService {
	private http = inject(HttpClient);
	private configService = inject(ConfigService);

	private get baseUrl() {
		return this.configService.configuration.apiUrl;
	}

	constructor() {}

	getUtente(id: number) {
		return this.http.get<Utente>(this.baseUrl + `/api/user/utente/${id}`);
	}

	updateUtente(utente: Utente) {
		return this.http.put<Utente>(this.baseUrl + `/api/user/utente/${utente.id}`, utente);
	}

	changePassword(tokenSegment: string, nuovaPassword: string, confermaNuovaPassword: string) {
		const body: UpdatePasswordRequest = { nuovaPassword, confermaNuovaPassword };
		return this.http.put(this.baseUrl + `/api/public/update-password/${tokenSegment}`, body);
	}
}
